var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:_vm.tagClasses},[(_vm.icon)?_c('svgicon',{class:[_vm.iconClasses, _vm.iconClass],attrs:{"name":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }